export default __webpack_public_path__ + "static/media/icon-user-access.a7330011.svg";